import { Link, Stack, Text } from "basis";
import { SvgInline } from "../../SvgInline/SvgInline";
import { ScreenProps, StatementPreferenceType } from "../reducer/types";

function displayMessage(
  pref: StatementPreferenceType,
  productName: string,
): string {
  if (pref.preference === "ONLINE") {
    if (pref.fee !== 0 && !pref.feeWaived) {
      const amount = (pref?.fee! / 100).toLocaleString("en-AU", {
        style: "currency",
        currency: "AUD",
      });
      return `You are now saving ${amount} each month by choosing to view your ${productName} statements online.`;
    }
    return `You will now receive your ${productName} statements online each month.`;
  }
  return `You will now receive your ${productName} statements via paper in the mail each month.`;
}

export const Success = ({
  state: { accountInfo, statementPreferences },
}: ScreenProps) => (
  <Stack gap="8">
    <SvgInline name="changed-statement-preference" size="92" />
    <Text as="h4" textStyle="heading4">
      Your statement preferences have been updated.
    </Text>
    <Text>
      {displayMessage(
        statementPreferences as StatementPreferenceType,
        accountInfo.cardName,
      )}
    </Text>
    <Link
      appearance="primary-button"
      variant="blue-button"
      width="216"
      href="/manage-account"
      newTab={false}
    >
      Manage account
    </Link>
  </Stack>
);
